module.exports = __webpack_public_path__ + "static/img/s2.5d951fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/s2.png
// module id = ziUt
// module chunks = 0